import { bookingInfoConstants } from 'store/constants';
import { bookingInfoService } from 'store/services/booking-info.service';
import { alertsActions, ticketActions } from '.';
import Booking, {
  bookingErrorStatuses,
} from 'store/models/bookings/Booking';
import {
  BookingInfo,
  BookingInfoResI,
} from 'store/models/BookingInfo';
import {
  bookingIdToInfoResSelector,
  bookingNosHasLoadedInfo,
} from 'store/selectors/booking-info.selector';
import getErrorMessage from 'utils/getErrorMessage';

const getManyBookingInfo = (
  bookingNos: string[],
  rowIndexes?: number[],
) => {
  console.debug(`getManyBookingInfo: `, bookingNos);
  if (!bookingNos.length) return;

  const request = () => {
    return {
      type: bookingInfoConstants.MANY_BOOKING_INFO_REQUEST,
      payload: { bookingNos, rowIndexes },
    };
  };
  const failure = (bookingNos: string[], error: string) => {
    return {
      type: bookingInfoConstants.MANY_BOOKING_INFO_ERROR,
      payload: { bookingNos, error, rowIndexes },
    };
  };
  const success = (bookingInfoRes: BookingInfoResI) => {
    return {
      type: bookingInfoConstants.MANY_BOOKING_INFO_SUCCESS,
      payload: { bookingInfoRes, rowIndexes },
    };
  };

  return async (dispatch): Promise<any> => {
    // check booking no format
    const fakeBookingNos = bookingNos.filter(
      (bn) => !Booking.isBookingNo(bn),
    );
    const realBookingNos = bookingNos.filter(
      (no) => !fakeBookingNos.includes(no),
    );

    if (fakeBookingNos.length > 0) {
      const errorMessages =
        bookingErrorStatuses.bookingNoIsNotRightFormat;
      dispatch(failure(fakeBookingNos, errorMessages));
    }
    try {
      dispatch(request());
      const data = await bookingInfoService.getManyBookingInfo(
        realBookingNos,
      );
      dispatch(success(data));
      return data;
    } catch (error) {
      const errorMessages = getErrorMessage(error);
      dispatch(failure(bookingNos, `${errorMessages}`));
      if (Array.isArray(errorMessages)) {
        errorMessages.forEach((err) => {
          dispatch(alertsActions.error(err, true));
        });
      } else {
        dispatch(alertsActions.error(errorMessages, false));
      }
    }
  };
};

const showBookingInfoAtIndex = (index: number) => {
  return {
    type: bookingInfoConstants.SHOW_BOOKING_INFO_AT_INDEX,
    payload: {
      index,
    },
  };
};

const reset = () => {
  return {
    type: bookingInfoConstants.RESET,
  };
};

const closeBookingInfo = () => {
  return {
    type: bookingInfoConstants.CLOSE_BOOKING_INFO,
  };
};

/**
 * call api if not existed
 */
const getBookingInfosIfNotFetched = (
  bookingNos: string[],
  rowIndexes?: number[],
) => {
  return async (dispatch, getState): Promise<any> => {
    const nosHasLoaded = bookingNosHasLoadedInfo(getState());

    const bookingsNosToLoad = bookingNos.filter(
      (bn) => !nosHasLoaded.includes(bn) && Booking.isBookingNo(bn),
    );

    let data;
    if (bookingsNosToLoad.length) {
      // get indexes of all these
      const bookingsNosToLoadRowIndexes =
        rowIndexes ||
        (bookingNos
          .map((bn, i) =>
            !nosHasLoaded.includes(bn) ? i : undefined,
          )
          .filter((item) => item !== undefined) as number[]);
      data = await dispatch(
        getManyBookingInfo(
          bookingsNosToLoad,
          bookingsNosToLoadRowIndexes,
        ),
      );
    } else {
      const bookingIdToInfoResObj = bookingIdToInfoResSelector(
        getState(),
      );
      if (bookingIdToInfoResObj) {
        bookingNos.forEach((bn) => {
          const { bookingInfoRes } = bookingIdToInfoResObj[bn] || {};
          if (bookingInfoRes) {
            if (!data) {
              data = bookingInfoRes;
            } else {
              // this is the issue
              data = {
                ...(data || {}),
                bookings: data.bookings.concat(
                  bookingInfoRes.bookings,
                ),
              };
            }
          }
        });
      }
    }
    return data;
  };
};

export const autoMarkIsSplit = (bookingNo: string) => {
  return async (dispatch) => {
    console.debug(
      `call auto mark splt `,
      Booking.isBookingNo(bookingNo),
    );
    if (bookingNo && Booking.isBookingNo(bookingNo)) {
      // // ********** related to booking/info **********
      const bookingInfo = await dispatch(
        bookingInfoActions.getBookingInfosIfNotFetched(
          [bookingNo],
          [-1],
        ),
      );

      if (bookingInfo) {
        const bM = new BookingInfo(bookingInfo);
        console.debug(`call auto mark splt bM: `, bM);
        if (bM.opusFound) {
          dispatch(
            ticketActions.applySplitInfoToTicket(bM.splitInfo),
          );
          dispatch(ticketActions.clearAutoMarkIsSplitError());
        } else if (!bM.opusError) {
          dispatch(
            ticketActions.setAutoMarkIsSplitError(
              `Boooking no. not found`,
            ),
          );
        } else {
          dispatch(
            ticketActions.setAutoMarkIsSplitError(
              `Could not connect to OPUS API to get split info`,
            ),
          );
        }
      }
    }
  };
};

export const bookingInfoActions = {
  showBookingInfoAtIndex,
  closeBookingInfo,
  getBookingInfosIfNotFetched,
  reset,
  getManyBookingInfo,
  autoMarkIsSplit,
};
